import React from 'react';
import Menu from './Menu.js';
import './App.scss';
import logo from './images/ICC_logo.png';
import banner from './images/choirbanner.png';
import insta from './images/insta_icon.png';
// import rehearsal from './images/bandstand-rehearsal.mp4'
import springConcert from './images/sing-in-the-spring.jpeg';
import bigBandGig from './images/big-band-gig.png'
import liftingAsWeRise from './images/liftingaswerise.jpeg'

function App() {
  return (
    <div className='main'>
      <Menu />
      <div className='content'>
        <img
          className='header-logo'
          src={logo}
          alt='Islington Community Choir logo'
        />
        <div className='section'>
          <h1 id='Home'>About us</h1>
          <p>
          The ICC was founded in 2016, we meet at New unity, 227a Upper street N1 2TZ at 11.30-1.30 on Sundays term time.
          Islington community choir has performed and collaborated with many other choirs and music ensembles such as the London Collective Big band, Filament choir, The Bellow fellows and Woven Gold.
            <br />
            We are proud supporters of the Islington Centre for Refugees and Migrants, who provide creative opportunities and skill sessions to vulnerable members of the community.
            <br />
            Our repertoire is incredibly varied, with many songs from other cultures and musical traditions. We encourage members to dance, move and fully immerse themselves in the joy of learning from all contexts and culturally honouring the source of each song.
            <br />
            Our choir is open to new members, and there is no need for previous singing experience. However the musical standard is quite high and we encourage you to come to a taster session to experience our way of learning and performing.
            <br />
            Our  taster sessions are:
            <br />
            September 7th & 14th
            <br />
            January 11th & 18th
            <br />
            March 22nd & 29th
          </p>

          <h1 id='Events'>Events</h1>
          <p>
            Sunday sessions are on come rain or shine at £10 per session with concessions available. You can also check out the
            good times from our past events on our instagram page:
            <br />
            <a href='https://www.instagram.com/islingtoncommunitychoir/'>
              <img className='insta-link' src={insta} alt='insta' />
            </a>
            <br />
          </p>
          <p>
          For our most recent performance this July we had the honour to team up with Woven Gold and the Filament Choir for a choir extravaganza show in Hoxton:
          <img
          //  width='30%'
            className='lifting-as-we-rise'
            src={liftingAsWeRise}
            alt='Lifting as we rise'
          /> 
          Previous shows include our supergroup collab concert with the
          <a href='https://www.facebook.com/groups/246339478848913/'>
          London Collective Big Band</a>
          with tight grooves, crunchy harmonies, and massive crowd favourites!
          </p>
          <img
          //  width='30%'
            className='big-band-gig'
            src={bigBandGig}
            alt='Big band gig'
          /> 
          <p>
            We're also proud to display our last concert in collaboration with
            the Bellow Fellows! The performance was a rousing mix of traditional and modern tunes
            from around the world, with proceeds going to the Islington Centre
            for Refugees & Immigrants.
          </p>
          <img
          //  width='30%'
            className='sing-in-the-spring'
            src={springConcert}
            alt='Spring Concert'
          />
          <h1 id='Contact'>Contact us</h1>
          <img className='print-banner' src={banner} alt='ICC Banner' />
          <p>
            Here's some of our old branding for those who may recognise us.
            <br />
            <br />
            If you have any other questions, just message us at
            islingtonvocalcollective@gmail.com or on our{' '}
            <a href='https://www.instagram.com/islingtoncommunitychoir/'>
              instagram
            </a>{' '}
            and we'll be in touch!
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
